import Vue from 'vue'
import currentSize from './mixins/currentSize'
import { createStore } from '../store/'
import IE11Attribute from './mixins/IE11Attribute'
import { log } from './entries/logging'
Vue.config.productionTip = false

import './registerComponents'

import kebabCase from 'lodash.kebabcase'

Vue.filter('kebab', function (value) {
  return kebabCase(value)
})

Vue.filter('stringify', function (val, sub) {
  if (sub && val instanceof Array) {
    return val.map( block => {
      if (sub) {
        if (block[sub] instanceof Array) {
          block[sub] = block[sub].length ? block[sub].join("") : ""
        }
      }
      return block
    })
  } else if (val instanceof Array) {
    return val.length ? val.join("") : ""
  }

  return val
})

import { getConfig } from './envConfig'
export function createApp (d, componentId, inEditMode, isLoggedIn, config) {
  const id = parseInt(componentId) ? `content_${componentId}` : componentId
  const kebabComponent = kebabCase(d.component)
  const tpl = `<${kebabComponent} v-bind="initdata" data-componentid="${id}"></${kebabComponent}>`

  // Only use vuex store in content and header as long as we have three separated vue instances that dont communicate
  const store = (id !== 'footer') ? createStore() : null

  //console.log(isContentApp, tpl) // Great debug to see which instances are loaded
  //Vue.config.devtools = true // Comment out this when building for prod
  const app = new Vue({
    mixins: [currentSize, IE11Attribute],
    store,
    data: {
      initdata: d,
      editMode: inEditMode,
      isLoggedIn: isLoggedIn,
      envConfig: getConfig(config)
    },
    mounted () {
      this.$ICALogin.trackRedirectedLogin()
    },
    template: tpl
  })

  Vue.config.errorHandler = function (error, _viewModel, info) {
    log(error, {
      info 
    })
  }

  return app
}
